// --- Streaming Error Codes ---
export const JANUS_STREAMING_ERROR_NO_SUCH_MOUNTPOINT = 456;
export const JANUS_STREAMING_ERROR_UNAUTHORIZED = 457;
export function isRetryableStreamingError(code) {
    return code === JANUS_STREAMING_ERROR_NO_SUCH_MOUNTPOINT
        || code === JANUS_STREAMING_ERROR_UNAUTHORIZED;
}
export const DEFAULT_CONFIG = {
    iceServers: [],
    keepaliveIntervalMs: 25000,
    keepaliveFailureThreshold: 3,
    longPollTimeoutMs: 45000,
    reconnectAttempts: 3,
    reconnectBackoffMs: 1000,
    statsIntervalMs: 2000,
    iceDisconnectedTimeoutMs: 5000,
    debug: false,
};
